var _g, _path, _path2, _path3, _path4, _path5, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCakeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 6L28 23.3159L31.3334 29.086L41.3335 11.7701L38.0001 6Z",
    fill: "#FFE573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3336 11.7701L31.3335 29.086L34.6669 34.8561L44.667 17.5458L41.3336 11.7701Z",
    fill: "url(#paint0_linear_3_272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 17.5458L34.6665 34.8561L37.9999 40.6263L48 23.3159L44.6666 17.5458Z",
    fill: "#FFE573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 6H38.0003L28.0002 23.3159H8L18.0001 6Z",
    fill: "#599CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 23.3159H8L18.0001 40.6262H38.0003L28.0002 23.3159Z",
    fill: "#3784CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_272",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 40,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 6L28 23.3159L31.3334 29.086L41.3335 11.7701L38.0001 6Z",
    fill: "#FFE573"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3336 11.7701L31.3335 29.086L34.6669 34.8561L44.667 17.5458L41.3336 11.7701Z",
    fill: "url(#paint1_linear_3_272)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 17.5458L34.6665 34.8561L37.9999 40.6263L48 23.3159L44.6666 17.5458Z",
    fill: "#FFE573"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 6H38.0003L28.0002 23.3159H8L18.0001 6Z",
    fill: "#599CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 23.3159H8L18.0001 40.6262H38.0003L28.0002 23.3159Z",
    fill: "#3784CB"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_272)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -23.019,
    y: -5.54208,
    width: 102.436,
    height: 57.7104,
    fill: "url(#pattern0)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_272",
    x: 0,
    y: 0,
    width: 56,
    height: 50.6263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_272",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_272",
    transform: "translate(-0.000782479) scale(0.000521648 0.000925926)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_272",
    x1: 41.3891,
    y1: 12.1833,
    x2: 35.2059,
    y2: 34.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_272",
    x1: 41.3891,
    y1: 12.1833,
    x2: 35.2059,
    y2: 34.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakeLogo);
export default __webpack_public_path__ + "static/media/cake-logo.0fc58c3091d500bafffadd4f1d69a2b2.svg";
export { ForwardRef as ReactComponent };